/*
 * Author M. Atoar Rahman
 * Title: Facility Stock Loss
 * Description: Page for Facility Stock Loss
 * Date: 15/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { FacilityStockLossProvider } from '../facility/stockLoss/ContextAPI';
import Index from '../facility/stockLoss/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityStockLoss() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-stock-loss']) return <PermissionDenied />;

    return (
        <FacilityStockLossProvider>
            <Index />
        </FacilityStockLossProvider>
    );
}
